if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              /* Chocosphere edit */
              if (soldOutMessage && response.status !== 422) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              }

              // For 422 errors with partial success, we need to fetch updated cart sections
              if (response.status === 422 && response.message.includes('items were added')) {
                try {
                  // Fetch updated cart sections since 422 response doesn't include them
                  const sectionsToFetch = this.cart.getSectionsToRender().map((section) => section.id);
                  const sectionsParam = sectionsToFetch.join(',');

                  const cartUpdateResponse = await fetch(`${window.location.pathname}?sections=${sectionsParam}`, {
                    headers: {
                      'X-Requested-With': 'XMLHttpRequest',
                    },
                  });
                  const cartUpdateData = await cartUpdateResponse.json();

                  // Create proper sections response format
                  const sectionsResponse = {
                    sections: cartUpdateData,
                  };

                  // For 422 errors, don't publish cartUpdate event to avoid other renderers clearing the error
                  // Just render the cart contents directly with the error message
                  if (this.cart && window.location.pathname !== window.routes.cart_url) {
                    this.cart.renderContents({
                      ...sectionsResponse,
                      id: this.productId,
                      errorMessage: response.message,
                    });
                  }

                  this.error = false; // Allow the form to be re-enabled
                  return;
                } catch (e) {
                  console.error('Error fetching updated cart sections:', e);
                  this.error = true;
                  return;
                }
              }

              // For other error statuses, don't update cart
              this.error = true;
              return;
            }

            // scroll to top on cart page
            const isOnCartPage = window.location.pathname === window.routes.cart_url;
            if (isOnCartPage) {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            /* End Chocosphere edit */

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      // Chocosphere edit - Don't open cart notification/drawer if already on cart page
                      if (!isOnCartPage) {
                        this.cart.renderContents(response);
                      }
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (!isOnCartPage) {
              // Chocosphere edit - Only render cart contents (which opens notification/drawer) if not on cart page
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
